import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Search, X } from 'lucide-react';
import { Input } from './ui/input';
import { Button } from './ui/button';

export default function SearchBar({ className = '' }) {
  const navigate = useNavigate();
  const [query, setQuery] = useState('');

  const handleSearch = (e) => {
    e?.preventDefault();
    if (query.trim()) {
      navigate({ pathname: '/shop', search: `search=${encodeURIComponent(query)}` });
    }
  };

  return (
    <div className={`w-full max-w-2xl mx-auto ${className}`}>
      <form onSubmit={handleSearch} className="relative flex items-center">
        <Search className="absolute left-4 top-1/2 -translate-y-1/2 h-5 w-5 text-muted-foreground" />
        <Input
          type="text"
          placeholder="What are you looking for?"
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          className="w-full pl-12 pr-12 py-6 text-base bg-background border-border rounded-lg shadow-sm focus:ring-1 focus:ring-foreground focus:border-foreground"
        />
        {query && (
          <Button
            type="button"
            variant="ghost"
            size="sm"
            className="absolute right-3 top-1/2 -translate-y-1/2 h-8 w-8 p-0 hover:bg-transparent"
            onClick={() => setQuery('')}
          >
            <X className="h-5 w-5 text-muted-foreground" />
          </Button>
        )}
        <Button
          type="submit"
          className="absolute right-1 top-1/2 -translate-y-1/2 h-9 px-4 bg-foreground text-background hover:bg-muted rounded-md"
        >
          <Search className="h-4 w-4" />
        </Button>
      </form>
    </div>
  );
}